import React, { useState } from 'react';

const products: { [key: string]: number } = {
  'SUPER DECO': 120.00,
  'SUPER DECO PLAIN': 55.56,
  'JET PRINT': 150.00,
  'ENDUREMAT 8mm branded': 150.00,
  'ENDUREMAT 15mm branded': 177.78,
  'ENDUREMAT 8mm plain': 127.78,
  'ENDUREMAT 15mm plain': 138.89,
  'NOVAMAT': 110.00,
  'DURABRITE': 110.00,
  'IRON HORSE': 110.00,
  'DOORMAT': 110.00,
};

const PricingCalculator: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState(Object.keys(products)[0]);
  const [length, setLength] = useState<string>('');
  const [width, setWidth] = useState<string>('');
  const [price, setPrice] = useState<number | null>(null);

  const handleCalculate = () => {
    const len = parseFloat(length);
    const wid = parseFloat(width);
    if (!isNaN(len) && !isNaN(wid) && len > 0 && wid > 0) {
      const area = len * wid;
      const calculatedPrice = area * products[selectedProduct];
      setPrice(calculatedPrice);
    } else {
      setPrice(null);
    }
  };

  const handleRefresh = () => {
    setSelectedProduct(Object.keys(products)[0]);
    setLength('');
    setWidth('');
    setPrice(null);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">Mat Pricing & Area Calculator</h1>
        <p className="text-center text-gray-500 mb-8">
          Effortlessly determine mat prices for custom or standard sizes. All prices are shown in US Dollars ($).
        </p>

        <div className="space-y-6">
          {/* Product Selection */}
          <div className="p-4 bg-green-50 rounded-lg">
            <label htmlFor="product-select" className="block text-sm font-medium text-green-800 mb-2">Select Product:</label>
            <select 
              id="product-select" 
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e.target.value)}
              className="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500"
            >
              {Object.entries(products).map(([name, price]) => (
                <option key={name} value={name}>
                  {name.toUpperCase()} (${price.toFixed(2)}/sqm)
                </option>
              ))}
            </select>
          </div>

          {/* Dimensions Input */}
          <div className="p-4 bg-blue-50 rounded-lg">
            <h2 className="text-sm font-medium text-blue-800 mb-3">Enter Dimensions</h2>
            <div className="space-y-4">
              <input 
                type="number" 
                placeholder="Enter length (m)" 
                value={length}
                onChange={(e) => setLength(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              <input 
                type="number" 
                placeholder="Enter width (m)" 
                value={width}
                onChange={(e) => setWidth(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>

          {price !== null && (
            <div className="p-4 bg-yellow-50 rounded-lg text-center">
              <h2 className="text-lg font-semibold text-yellow-800">Estimated Price:</h2>
              <p className="text-2xl font-bold text-gray-800">${price.toFixed(2)}</p>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex items-center justify-between space-x-4 pt-4">
            <button onClick={handleCalculate} className="w-full bg-green-500 text-white font-bold py-3 px-4 rounded-lg hover:bg-green-600 transition duration-300">
              Calculate Price
            </button>
            <button onClick={handleRefresh} className="w-full bg-red-500 text-white font-bold py-3 px-4 rounded-lg hover:bg-red-600 transition duration-300">
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingCalculator;
